// extracted by mini-css-extract-plugin
module.exports = {"Title":"Title_Title__3OV6n","Title__Landing":"Title_Title__Landing__1wmDo","Title__Header":"Title_Title__Header__loZZf","Title__List":"Title_Title__List__2ISKx"};